import Vue from 'vue'

export default {
  // 设置用户信息
  setUserInfo(state, params) {
    if (!params) {
      state.userInfo = {}
      localStorage.setItem('token', '')
    } else {
      for (let k in params) {
        Vue.set(state.userInfo, k, params[k])
      }
      localStorage.setItem('token', state.userInfo.token || '')
    }
  },
  // 设置年份列表
  setYearList(state) {
    let num = 7
    let dateArr = []
    let date = new Date().getFullYear()
    for (let i = 0; i < num; i++) {
      dateArr.push(date - i)
    }
    state.yearList = dateArr
  },

  setResourceInfoDict(state, params) {
    state.resourceInfoDict = {
      ...state.resourceInfoDict,
      ...(params || {})
    }
  },
  setGradeVolumeList(state, params) {
    state.gradeVolumeList = params || []
  },
  setMessageParams(state, params) {
    state.messageParams = params || {}
  }
}
